var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    property,
    listing_class,
    listing_index,
    omtag,
    browse_module_count,
    is_mobile
  } = options;

__p+='\n\n';

// Set up classes for each of the listing cards (Show different number of cards at different breakpoints)
var classes_per_breakpoint = ['col-md-3', 'col-md-4', 'col-md-5', 'col-md-5 hidden-xxs', 'col-md-4 hidden-xxs', 'col-md-3 hidden-xxs'];
listing_class = '';
if((listing_index <= 2 && browse_module_count >= 3) || (listing_index >= 3 && browse_module_count == 6 && !is_mobile) || is_mobile){
    listing_class = classes_per_breakpoint[listing_index];
}
var browser_small =  '';
if(!is_mobile){
    browser_small = 'col-xs-4';
}

__p+='\n';
 if(listing_class!== ''){ 
__p+='\n<div class="listing-'+
((__t=( listing_index ))==null?'':__t)+
' col-xxs-12 '+
((__t=( browser_small ))==null?'':__t)+
' '+
((__t=( listing_class ))==null?'':__t)+
' item">\n    <div class="listing-card-filled listing-card-short">\n        <div class="aspect-content" itemscope itemtype="http://schema.org/SingleFamilyResidence">\n            <div class="listing-photo">\n                <a href="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" data-omtag="'+
((__t=( omtag ))==null?'':__t)+
'" itemprop="url">\n                    ';
 if(property.photo_url){ 
__p+='\n                    <span><img class ="js-ldp-listing-photos" data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'" src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" lazy=true data-pin-nopin=“true”></span>\n                    ';
 } else { 
__p+='\n                    <span class="photo-coming-soon"></span>\n                    ';
 } 
__p+='\n                </a>\n                <div class="listing-photo-label">\n                    ';
 if(property.search_flags.is_new_listing){ 
__p+='\n                    <span class="display-inline-block label label-green" data-label="property-label-new">New</span>\n                    ';
 } 
__p+='\n                    ';
 if(property.search_flags.is_pending){ 
__p+='\n                    <span class="display-inline-block label label-red" data-label="property-label-pending">Pending</span>\n                    ';
 } 
__p+='\n                    ';
 if(property.search_flags.is_contingent){ 
__p+='\n                    <span class="display-inline-block label label-red" data-label="property-label-contingent">Contingent</span>\n                    ';
 } 
__p+='\n                </div>\n            </div>\n            <div class="listing-info">\n                <ul class="list-unstyled property-meta">\n                    <li class="listing-info-address ellipsis" title="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n              <span itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">\n                  ';
 if (property.address){ 
__p+='\n                  <span itemprop="streetAddress">'+
((__t=( property.address ))==null?'':__t)+
'</span>,\n                  ';
 } 
__p+='\n                  ';
 if (property.city){ 
__p+='\n                  <span itemprop="addressLocality">'+
((__t=( property.city ))==null?'':__t)+
'</span>,\n                  ';
 } 
__p+='\n                  <span itemprop="addressRegion">'+
((__t=( property.state_code ))==null?'':__t)+
'</span>\n                  <span itemprop="postalCode">'+
((__t=( property.postal_code ))==null?'':__t)+
'</span>\n               </span>\n              <span itemprop="geo" itemscope itemtype="http://schema.org/GeoCoordinates">\n                  <meta itemprop="latitude" content="'+
((__t=( property.lat ))==null?'':__t)+
'"></meta>\n                  <meta itemprop="longitude" content="'+
((__t=( property.lon ))==null?'':__t)+
'"></meta>\n              </span>\n                    </li>\n                    <li class="listing-info-price">\n                        '+
((__t=( property.price_display ))==null?'':__t)+
'\n                        <div class="listing-card-tags">\n                        </div>\n                    </li>\n                    <li class="listing-info-meta">\n                        <ul class="list-horizontal list-style-disc">\n                            ';
 if (property.beds){ 
__p+='\n                            <li data-label="property-meta-beds"><span class="data-value" itemprop="numberofRooms">'+
((__t=( property.beds ))==null?'':__t)+
'</span> bd</li>\n                            ';
 } 
__p+='\n                            ';
 if (property.baths){ 
__p+='\n                            <li data-label="property-meta-baths"><span class="data-value">'+
((__t=( property.baths ))==null?'':__t)+
'</span> ba</li>\n                            ';
 } 
__p+='\n                            ';
 if (property.sqft_display){ 
__p+='\n                            <li class="property-meta-sqft " data-label="property-meta-sqft"><span class="data-value" itemprop="floorSize">'+
((__t=( property.sqft_display ))==null?'':__t)+
'</span> sq ft</li>\n                            ';
 } 
__p+='\n                        </ul>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/news_advice_browse_modules_card.jst.ejs